import { addMethod, string, number } from 'yup';
function e(b, a) {
  if (!(b instanceof a)) throw new TypeError("Cannot call a class as a function");
}
function h(b, a) {
  for (var c = 0; c < a.length; c++) {
    var d = a[c];
    d.enumerable = d.enumerable || !1;
    d.configurable = !0;
    "value" in d && (d.writable = !0);
    Object.defineProperty(b, d.key, d);
  }
}
function k(b, a, c) {
  a && h(b.prototype, a);
  c && h(b, c);
  return b;
}
function m(b, a, c) {
  a in b ? Object.defineProperty(b, a, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : b[a] = c;
  return b;
}
function n(b, a) {
  if ("function" !== typeof a && null !== a) throw new TypeError("Super expression must either be null or a function");
  b.prototype = Object.create(a && a.prototype, {
    constructor: {
      value: b,
      writable: !0,
      configurable: !0
    }
  });
  a && p(b, a);
}
function q(b) {
  q = Object.setPrototypeOf ? Object.getPrototypeOf : function (a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  };
  return q(b);
}
function p(b, a) {
  p = Object.setPrototypeOf || function (a, b) {
    a.__proto__ = b;
    return a;
  };
  return p(b, a);
}
function r() {
  if ("undefined" === typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
  if ("function" === typeof Proxy) return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (b) {
    return !1;
  }
}
function t(b, a, c) {
  t = r() ? Reflect.construct : function (a, c, b) {
    var d = [null];
    d.push.apply(d, c);
    a = new (Function.bind.apply(a, d))();
    b && p(a, b.prototype);
    return a;
  };
  return t.apply(null, arguments);
}
function u(b) {
  var a = "function" === typeof Map ? new Map() : void 0;
  u = function u(c) {
    function b() {
      return t(c, arguments, q(this).constructor);
    }
    if (null === c || -1 === Function.toString.call(c).indexOf("[native code]")) return c;
    if ("function" !== typeof c) throw new TypeError("Super expression must either be null or a function");
    if ("undefined" !== typeof a) {
      if (a.has(c)) return a.get(c);
      a.set(c, b);
    }
    b.prototype = Object.create(c.prototype, {
      constructor: {
        value: b,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    });
    return p(b, c);
  };
  return u(b);
}
function v(b) {
  var a = r();
  return function () {
    var c = q(b);
    if (a) {
      var d = q(this).constructor;
      c = Reflect.construct(c, arguments, d);
    } else c = c.apply(this, arguments);
    if (!c || "object" !== typeof c && "function" !== typeof c) {
      if (void 0 === this) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      c = this;
    }
    return c;
  };
}
var w = function (b) {
  function a() {
    e(this, a);
    return c.call(this, "Invalid swedish personal identity number");
  }
  n(a, b);
  var c = v(a);
  return a;
}(u(Error));
function x(b, a) {
  b = b.getTime() - a.getTime();
  return 0 > b ? -1 : 0 < b ? 1 : b;
}
function y(b, a, c) {
  --a;
  var d = new Date(b, a, c);
  return !(d.getFullYear() !== b || d.getMonth() !== a || d.getDate() !== c);
}
var z = function () {
  function b(a, c) {
    e(this, b);
    m(this, "_century", "");
    m(this, "_fullYear", "");
    m(this, "_year", "");
    m(this, "_month", "");
    m(this, "_day", "");
    m(this, "_sep", "");
    m(this, "_num", "");
    m(this, "_check", "");
    this.parse(a, c);
  }
  k(b, [{
    key: "century",
    get: function get() {
      return this._century;
    }
  }, {
    key: "fullYear",
    get: function get() {
      return this._fullYear;
    }
  }, {
    key: "year",
    get: function get() {
      return this._year;
    }
  }, {
    key: "month",
    get: function get() {
      return this._month;
    }
  }, {
    key: "day",
    get: function get() {
      return this._day;
    }
  }, {
    key: "sep",
    get: function get() {
      return this._sep;
    }
  }, {
    key: "num",
    get: function get() {
      return this._num;
    }
  }, {
    key: "check",
    get: function get() {
      return this._check;
    }
  }]);
  k(b, [{
    key: "parse",
    value: function value(a) {
      var c = /^(\d{2}){0,1}(\d{2})(\d{2})(\d{2})([+\-\s]?)((?!000)\d{3})(\d)$/.exec(a);
      if (!c) throw new w();
      var b = c[1];
      a = c[2];
      var f = c[3],
        g = c[4],
        l = c[5],
        A = c[6];
      c = c[7];
      "undefined" !== typeof b && b.length ? (this._century = b, 100 > new Date().getFullYear() - parseInt(b + a, 10) ? this._sep = "-" : this._sep = "+") : (b = new Date(), "+" === l ? (this._sep = "+", l = b.getFullYear() - 100) : (this._sep = "-", l = b.getFullYear()), this._century = ("" + (l - (l - parseInt(a)) % 100)).substr(0, 2));
      this._year = a;
      this._fullYear = this._century + a;
      this._month = f;
      this._day = g;
      this._num = A;
      this._check = c;
      if (!this.valid()) throw new w();
    }
  }, {
    key: "valid",
    value: function value() {
      var a = this.year + this.month + this.day + this.num,
        b = 0;
      a += "";
      for (var d = 0, f = a.length; d < f; d++) {
        var g = parseInt(a[d]);
        g *= 2 - d % 2;
        9 < g && (g -= 9);
        b += g;
      }
      return (a = 10 * Math.ceil(b / 10) - b === +this.check && !!this.check) && y(parseInt(this.century + this.year), +this.month, +this.day) ? a : a && y(parseInt(this.century + this.year), +this.month, +this.day - 60);
    }
  }, {
    key: "format",
    value: function value() {
      return 0 < arguments.length && void 0 !== arguments[0] && arguments[0] ? "".concat(this.century).concat(this.year).concat(this.month).concat(this.day).concat(this.num).concat(this.check) : "".concat(this.year).concat(this.month).concat(this.day).concat(this.sep).concat(this.num).concat(this.check);
    }
  }, {
    key: "getAge",
    value: function value() {
      var a = +this.day;
      this.isCoordinationNumber() && (a -= 60);
      var b = this.century + this.year + "-" + this.month + "-" + a;
      a = new Date(Date.now());
      var d = new Date(b);
      b = x(a, d);
      var f = Math.abs(a.getFullYear() - d.getFullYear());
      a.setFullYear(a.getFullYear() - b * f);
      a = x(a, d) === -b;
      a = b * (f - +a);
      return 0 === a ? 0 : a;
    }
  }, {
    key: "isCoordinationNumber",
    value: function value() {
      return y(parseInt(this.century + this.year), +this.month, +this.day - 60);
    }
  }, {
    key: "isFemale",
    value: function value() {
      return !this.isMale();
    }
  }, {
    key: "isMale",
    value: function value() {
      return 1 === parseInt(this.num.substr(-1)) % 2;
    }
  }], [{
    key: "parse",
    value: function value(a, c) {
      return new b(a, c);
    }
  }, {
    key: "valid",
    value: function value(a, c) {
      try {
        return b.parse(a, c), !0;
      } catch (d) {
        return !1;
      }
    }
  }]);
  return b;
}();
function B() {
  var b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return this.test("personnummer", "string" === typeof b ? b : "${path} must be a valid Swedish personal identity number.", function (a) {
    return a ? z.valid(a) : !1;
  });
}
addMethod(string, "personnummer", B);
addMethod(number, "personnummer", B);